import { useNavigate } from 'react-router-dom';
import Logo from '@/assets/orcar_global_logo.svg';

const SideBarItem = ({ text }: { text: string }) => {
  return (
    <div className='font-montserrat cursor-pointer p-3 text-[16px] font-bold tracking-[-0.24px] text-grey-010'>
      {text}
    </div>
  );
};

const SideBar = () => {
  const navigate = useNavigate();

  return (
    <div className='flex h-full w-[264px] min-w-[264px] flex-col justify-between bg-primary-090 px-7 pb-10 pt-20 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] backdrop-blur-[7.5px]'>
      <div className='flex flex-col gap-[30px]'>
        <img
          className='cursor-pointer'
          src={Logo}
          alt='logo'
          width={173}
          height={50}
          onClick={() => {
            navigate('/mobi');
          }}
        />
        <div className='h-px bg-grey-030/50' />
        <div className='flex flex-col gap-2'>
          <SideBarItem text='Log in/Sign in' />
          <SideBarItem text='My Page' />
          <SideBarItem text='Orcar Travel Blog' />
          <SideBarItem text='About Orcar' />
          <button
            className='font-montserrat cursor-pointer p-3 text-start text-[16px] font-bold tracking-[-0.24px] text-grey-010'
            data-tally-open='wLoOlz'
            data-tally-emoji-text='👋'
            data-tally-emoji-animation='wave'
          >
            Survey 😘
          </button>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
